import easydropdown from 'easydropdown';

export default class DropdownMenu {

	static init() {
		// init easy dropdown and destroy all instances inside flatpickr
		const selects = document.querySelectorAll('select.easydropdown');
		selects.forEach((select) => {
			const edd = easydropdown(select);
		})

		const flatpickrInstances = document.querySelectorAll('.flatpickr-calendar select');
		flatpickrInstances.forEach((select) => {
			const edd = easydropdown(select);
			edd.destroy();
		});
	}
}
